import React, { useState, useEffect } from "react";
import { Table, Button, Form, Badge, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";

const Comenzi = ({ deschideDocumente }) => {
  const [lista, setLista] = useState([]);
  const [reaf, setReaf] = useState(false);
  const [client, setClient] = useState("");
  const [codTva, setCodTva] = useState("");
  const [tara, setTara] = useState("");
  const [produse, setProduse] = useState("");
  const [valoare, setValoare] = useState("");
  const [dataComanda, setDataComanda] = useState("");

  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [cautare, setCautare] = useState("");
  const citescComenzi = async () => {
    const obPromise = await fetch("/comenzi");
    const sirComenzi = await obPromise.json();
    setLista(sirComenzi);
  };

  useEffect(() => {
    citescComenzi();
  }, [reaf]);

  const nrDoc = (c) => {
    let nr = 0;
    if (c.factura?.numar) nr++;
    if (c.uit?.cod) nr++;
    if (c.cmr?.numar) nr++;
    if (c.declaratie?.semnat === "da") nr++;
    return nr;
  };

  const adaugComanda = async (evt) => {
    evt.preventDefault();
    const comanda = {
      client,
      cod_tva: codTva,
      tara,
      produse,
      valoare: Number(valoare),
      data_comanda: dataComanda,
      status: "in pregatire",
      factura: { numar: "", data: "", status: "neemisa" },
      uit: { cod: "", data: "", status: "neemis" },
      cmr: { numar: "", transportator: "", data: "", status: "nesemnat" },
      declaratie: { data: "", semnat: "nu", status: "neconfirmata" },
    };
    await fetch("/adaugcomanda", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(comanda),
    });
    setClient("");
    setCodTva("");
    setTara("");
    setProduse("");
    setValoare("");
    setDataComanda("");
    setReaf(!reaf);
  };

  const stergeComanda = async (id) => {
    if (window.confirm("Sigur doriti stergerea?")) {
      await fetch(`/sterge/${id}`, { method: "DELETE" });
      setReaf(!reaf);
    }
  };
  const incepEditare = (comanda) => {
    setEditId(comanda.id);
    setEditData({
      client: comanda.client,
      cod_tva: comanda.cod_tva,
      tara: comanda.tara,
      produse: comanda.produse,
      valoare: comanda.valoare,
      data_comanda: comanda.data_comanda,
    });
  };

  const salveazaEditare = async () => {
    await fetch(`/actualizez/${editId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editData),
    });
    setEditId(null);
    setReaf(!reaf);
  };

  return (
    <>
      <h2 className="mb-3">Comenzi intracomunitare</h2>
      <Form.Control
        type="text"
        placeholder="Cauta dupa client sau data..."
        className="mb-3"
        value={cautare}
        onChange={(e) => setCautare(e.target.value)}
      />
      <Table striped bordered hover responsive>
        <thead className="table-dark">
          <tr>
            <th>Client</th>
            <th>Cod TVA</th>
            <th>Tara</th>
            <th>Produse</th>
            <th>Valoare EUR</th>
            <th>Data</th>
            <th>Dosar</th>
            <th>Actiuni</th>
          </tr>
        </thead>
        <tbody>
          {lista
            .filter(
              (c) =>
                c.client.toLowerCase().includes(cautare.toLowerCase()) ||
                c.data_comanda.includes(cautare),
            )
            .map((comanda) => (
              <tr key={comanda.id}>
                <td>
                  {editId === comanda.id ? (
                    <input
                      className="form-control form-control-sm"
                      value={editData.client}
                      onChange={(e) =>
                        setEditData({ ...editData, client: e.target.value })
                      }
                    />
                  ) : (
                    comanda.client
                  )}
                </td>
                <td>
                  <small>
                    {editId === comanda.id ? (
                      <input
                        className="form-control form-control-sm"
                        value={editData.cod_tva}
                        onChange={(e) =>
                          setEditData({ ...editData, cod_tva: e.target.value })
                        }
                      />
                    ) : (
                      comanda.cod_tva
                    )}
                  </small>
                </td>
                <td>
                  {editId === comanda.id ? (
                    <input
                      className="form-control form-control-sm"
                      value={editData.tara}
                      onChange={(e) =>
                        setEditData({ ...editData, tara: e.target.value })
                      }
                    />
                  ) : (
                    comanda.tara
                  )}
                </td>
                <td>
                  <small>
                    {editId === comanda.id ? (
                      <input
                        className="form-control form-control-sm"
                        value={editData.produse}
                        onChange={(e) =>
                          setEditData({ ...editData, produse: e.target.value })
                        }
                      />
                    ) : (
                      comanda.produse
                    )}
                  </small>
                </td>
                <td>
                  {editId === comanda.id ? (
                    <input
                      className="form-control form-control-sm"
                      value={editData.valoare}
                      onChange={(e) =>
                        setEditData({ ...editData, valoare: e.target.value })
                      }
                    />
                  ) : (
                    comanda.valoare
                  )}
                </td>
                <td>
                  {editId === comanda.id ? (
                    <input
                      className="form-control form-control-sm"
                      value={editData.data_comanda}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          data_comanda: e.target.value,
                        })
                      }
                    />
                  ) : (
                    comanda.data_comanda
                  )}
                </td>
                <td>
                  <Badge
                    bg={
                      nrDoc(comanda) === 4
                        ? "success"
                        : nrDoc(comanda) > 0
                          ? "warning"
                          : "danger"
                    }
                  >
                    {nrDoc(comanda)}/4
                  </Badge>
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="primary"
                    className="me-1"
                    as={Link}
                    to="/documente"
                    onClick={() => deschideDocumente(comanda)}
                  >
                    Documente
                  </Button>
                  {editId === comanda.id ? (
                    <Button
                      size="sm"
                      variant="success"
                      className="me-1"
                      onClick={salveazaEditare}
                    >
                      Salveaza
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      variant="warning"
                      className="me-1"
                      onClick={() => incepEditare(comanda)}
                    >
                      Editeaza
                    </Button>
                  )}
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => stergeComanda(comanda.id)}
                  >
                    Sterge
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      {lista.length === 0 && (
        <p className="text-muted text-center">Nu exista comenzi.</p>
      )}

      <h4 className="mt-4">Adauga comanda noua</h4>
      <Form
        onSubmit={adaugComanda}
        style={{
          backgroundColor: "#ddd",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <Form.Group className="mb-3">
          <Form.Label>Client:</Form.Label>
          <Form.Control
            type="text"
            value={client}
            onChange={(e) => setClient(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Cod TVA intracomunitar:</Form.Label>
          <Form.Control
            type="text"
            value={codTva}
            onChange={(e) => setCodTva(e.target.value)}
            placeholder="ex: DE123456789"
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Tara destinatie:</Form.Label>
          <Form.Select
            value={tara}
            onChange={(e) => setTara(e.target.value)}
            required
          >
            <option value="">-- Selectati --</option>
            <option>Germania</option>
            <option>Austria</option>
            <option>Franta</option>
            <option>Italia</option>
            <option>Spania</option>
            <option>Belgia</option>
            <option>Olanda</option>
            <option>Polonia</option>
            <option>Alta tara UE</option>
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Produse:</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            value={produse}
            onChange={(e) => setProduse(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Valoare (EUR):</Form.Label>
          <Form.Control
            type="number"
            value={valoare}
            onChange={(e) => setValoare(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Data comanda:</Form.Label>
          <Form.Control
            type="date"
            value={dataComanda}
            onChange={(e) => setDataComanda(e.target.value)}
            required
          />
        </Form.Group>
        <Button variant="primary" type="submit">
          Adauga comanda
        </Button>
      </Form>
    </>
  );
};

export default Comenzi;
